/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ItemHeartWrapper_viewer$ref = any;
export type StorefrontProductTile_viewer$ref = any;
export type StorefrontProductTile_viewer = {
    readonly " $fragmentRefs": ItemHeartWrapper_viewer$ref;
    readonly " $refType": StorefrontProductTile_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontProductTile_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": null
        },
        {
            "kind": "RootArgument",
            "name": "userIds",
            "type": null
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ItemHeartWrapper_viewer",
            "args": [
                {
                    "kind": "Variable",
                    "name": "loadPortfolioData",
                    "variableName": "hasUserId"
                },
                {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userIds"
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'dc02e0f25895beaf6d94f824ca0cba43';
export default node;
